import React from "react";
import { FormattedMessage } from "react-intl";
import FeedbackOK from "../../../../assets/img/deadlines-merge-feedback-ok.svg";
import FeedbackKO from "../../../../assets/img/deadlines-merge-feedback-ko.svg";

const Content3 = props => {
  const { feedback, isOpposite, isZeroResidual } = props;

  const messageID =
    feedback === "ok"
      ? isZeroResidual
        ? "deadlines.merge.description3Zero"
        : "deadlines.merge.description3"
      : (isOpposite ? "deadlines.compensation.description3ko" : "deadlines.merge.description3ko");
  return (
    <div className={"deadlinesDialogMerge-content3"}>
      <div className={"deadlinesDialogMerge-img3"}>
        <img src={feedback === "ok" ? FeedbackOK : FeedbackKO} alt="" />
      </div>
      <div className={"deadlinesDialogMerge-description3"}>
        {<FormattedMessage id={messageID} />}
      </div>
    </div>
  );
};

export default Content3;
